export var easeIn = 'ease-in'; // cubic-bezier(0.42, 0, 1, 1);

export var easeOut = 'ease-out'; // cubic-bezier(0, 0, 0.58, 1);

export var easeInOut = 'ease-in-out'; // cubic-bezier(0.42, 0, 0.58, 1)

/**
 * easeInOutQuad implements the ease-in-out css motion in javascript.
 * This function is meant to be used with a loop/requestAnimationFrame.
 * Loop & increment currentTime until totalDuration
 * @param {Number} currentTime - current frame time to animate (that is less than totalDuration)
 * @param {Number} startPosition - starting position of the animation
 * @param {Number} totalDistance - total distance to travel (destination position - startPosition)
 * @param {Number} totalDuration - total duration of animation
 */

export var easeInOutQuad = function easeInOutQuad(currentTime, startPosition, totalDistance, totalDuration) {
  var workingTime = currentTime / (totalDuration / 2);

  if (workingTime < 1) {
    return totalDistance / 2 * workingTime * workingTime + startPosition;
  }

  workingTime--;
  return -totalDistance / 2 * (workingTime * (workingTime - 2) - 1) + startPosition;
};
export var verySlow = '500ms';
export var slow = '400ms';
export var normal = '300ms';
export var fast = '200ms';
export var veryFast = '100ms';
/** don't put these into theme, it's too verbose */

export default {
  easeIn: easeIn,
  easeOut: easeOut,
  easeInOut: easeInOut,
  easeInOutQuad: easeInOutQuad,
  verySlow: verySlow,
  slow: slow,
  normal: normal,
  fast: fast,
  veryFast: veryFast
};